/* eslint-disable no-unused-vars */

const convertMillimeterToInches = ({ value, toFixed = 7 }) => {
  let val = value ? Number(value / 25.4) : null;
  return val ? +val.toFixed(toFixed) : val;
};

const convertInchesToMillimeter = ({ value, toFixed = 5 }) => {
  let val = value ? Number(value * 25.4) : null;
  return val ? +val.toFixed(toFixed) : val;
};

export { convertInchesToMillimeter, convertMillimeterToInches };
